import { inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { AuthStatusService } from './auth-status.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SyndicatedHeaderService {

  private readonly configService = inject(ConfigService);
  private readonly authStatusService = inject(AuthStatusService);

  public async initialize(): Promise<void> {
    try {
      await this._loadScript();
      const { isLoggedIn } = await firstValueFrom(this.authStatusService.getStatus());
      if (isLoggedIn) {
        await window['PEP']?.PROFILE_AUTH?.getSWIDAndToken();
      } else {
        await window['PEP']?.PROFILE_AUTH?.launchIdentityFlow();
      }
    } catch (e) {
      console.error('[SyndicatedHeaderService] Error during authentication flow', { error: e });
      if (e !== 'Not logged in') {
        console.error('[SyndicatedHeaderService] ClientIntegration error: ', e);
      }

      try {
        await this._loadScript();
      } catch (err) {
        console.error('[SyndicatedHeaderService] Error loading NavUI', err);
      }
    }
  }

  private _loadScript(): Promise<void> {
    const src = `${this.configService.SYNDICATED_HEADER_URL}&isUniversalAuthEnabled=true`;

    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = () => {
        console.log('[SyndicatedHeaderService] NavUI script loaded successfully');
        resolve();
      };
      s.onerror = (error) => {
        console.error('[SyndicatedHeaderService] Failed to load NavUI script', error);
        reject(error);
      };
      document.body.appendChild(s);
    });
  }
}
